import { Component, OnInit } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';
import { ICompany } from 'app/shared/Domains/company';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { Router } from '@angular/router';
import { AuthService } from 'common/services/auth.service';
import { IUser } from 'app/shared/Domains/IUser';
import { IBranch } from 'app/shared/Domains/branch';
import { Configuration } from "config/config";
@Component({
  selector: 'app-admission-report',
  templateUrl: './admission-report.component.html',
  styleUrls: ['./admission-report.component.css', '../report-shell.css']
})
export class AdmissionReportComponent implements OnInit {

  memberAdmissionsReport: any[] = [];
  options: any[];
  company: ICompany;
  branch: IBranch;
  selectedOption: any;
  loading: boolean;
  from: any;
  visitorContact: any;
  to: any;
  tagNumber: any;
  trainer: any;
  date: any;
  totalRegistrationFee: number = 0;
  totalmontlyFee: number = 0;
  total: number = 0;
  user:IUser;
  constructor(public config: Configuration,private messageService: MessageService, private appServiceManager: AppServiceManager, private route: Router) {
  }

  ngOnInit() {
    this.InitObjects();
    this.user = AuthService.getLoggedInUser();
  }

  InitObjects() {
    this.company = new ICompany();
    this.branch = new IBranch();
    this.getCompany();
    this.getBranch();
    this.loading = false;
    this.resetFilter();
    this.options = [
      { label: 'Search All Member', value: 'AllMember' },
      { label: 'Search By Member', value: 'Member' },
    ];

  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    let user = JSON.parse(localStorage.getItem('currentUser'));
    if(!this.company){

    this.appServiceManager.get('companies/current').subscribe((res) => {
      if (res) {
        this.company = res;
      } else {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  }
  getBranch() {
    this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  resetFilter() {
    this.memberAdmissionsReport = [];
    this.selectedOption = 'AllMember';
    this.tagNumber = "";
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.totalRegistrationFee = 0;
    this.totalmontlyFee = 0;
    this.total = 0;
  }

  dropdownChange() {
    this.tagNumber = "";
    this.visitorContact = "";
    this.trainer = "";
  }

  validateData(data) {
    if (data.search === "Member") {
      if (data.Member !== "") {
        return true;
      } else {
        return false;
      }
    }
    else if (data.search === "AllMember") {
      return 4;
    }
    else {
      return false;
    }
  }

  search() {
    this.memberAdmissionsReport = [];
    let data = {
      from: new Date(this.from),
      to: new Date(this.to),
      search: this.selectedOption,
      Member: this.tagNumber,
      company: this.user.company,
      branch: this.user.branch
    }
    let check = this.validateData(data);
    if (check === true) {
      this.loading = true;
      this.appServiceManager.post('customers/admissionReport', data).subscribe((res) => {
        if (res.length > 0) {
          this.memberAdmissionsReport = res;
          this.memberAdmissionsReport = this.memberAdmissionsReport.sort((a, b) => { return <any>new Date(b.joiningDate) - <any>new Date(a.joiningDate) });
          this.sumRegistrationFee(this.memberAdmissionsReport);
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "Record not found" });
        }
        this.loading = false;
      },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
    else if (check === 4) {
      this.loading = true;
      this.appServiceManager.post('customers/admissionReport', data).subscribe((res) => {
        if (res.length > 0) {
          this.memberAdmissionsReport = res;
          this.memberAdmissionsReport = this.memberAdmissionsReport.sort((a, b) => { return <any>new Date(b.joiningDate) - <any>new Date(a.joiningDate) });
          this.sumRegistrationFee(this.memberAdmissionsReport);
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "Record not found" });
        }
        this.loading = false;
      },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
    else {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "Please Complete the fields" });
    }
  }

  sumRegistrationFee(memberAdmissionsReport: any[] = []) {
    this.totalRegistrationFee = 0;
    this.totalmontlyFee = 0;
    this.total = 0;
    memberAdmissionsReport.forEach((member) => {
      this.totalRegistrationFee += parseInt(member.registerationFee);
      this.totalmontlyFee += parseInt(member.monthFee);
      this.total += parseInt(member.registerationFee) + parseInt(member.monthFee);
    })

  }

  viewDetail(member) {
    this.route.navigateByUrl("members/member/" + member._id);
  }

  printAllInvoice(): void {
    let printContents, popupWin;
    printContents = document.getElementById('allmemberAdmissionsReport').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
        <title>All Admission Report</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `
    );
  }

}
